export default __webpack_public_path__ + "static/media/cropped.46bf2346.jpg";